import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from 'app/shared/nav/sliding/sliding.module.css';

const DashboardSlidingNav = ({ actions = null, nav_items, className, onTabChange, activeTab }) => {
  const [items, setItems] = useState([]);
  const [active_item, setActiveItem] = useState('');

  useEffect(() => {
    if (!nav_items || !nav_items.length) return;
    setItems(nav_items);

    if (!active_item && activeTab) {
      setActiveItem(activeTab);
    } else if (!active_item) {
      const initialTab = nav_items[0].path;
      setActiveItem(initialTab);
      if (onTabChange) onTabChange(initialTab);
    }
  }, [nav_items, activeTab, active_item, onTabChange]);

  useEffect(() => {
    if (activeTab && activeTab !== active_item) {
      setActiveItem(activeTab);
    }
  }, [activeTab, active_item]);

  const handleNavigation = (path, event) => {
    event.preventDefault();
    event.target.blur();
    setActiveItem(path);
    if (onTabChange) {
      onTabChange(path);
    }
  };

  return (
    <>
      <div className={cx(styles.slidingNav, className)}>
        <div>
          {items.map((item) => (
            <span key={item.path}>
              <button
                type="button"
                onClick={(e) => handleNavigation(item.path, e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  fontSize: 'inherit',
                  fontFamily: 'inherit',
                  outline: 'none',
                  boxShadow: 'none',
                  WebkitTapHighlightColor: 'transparent'
                }}
                onFocus={(e) => e.target.blur()}
              >
                <span
                  className={cx(styles.navItem, active_item === item.path && styles.activeItem)}
                >
                  {item.name || item.title || ''}
                </span>
              </button>
            </span>
          ))}
        </div>
        <div className={styles.actions}>{actions}</div>
      </div>
      <div className={styles.mobileActions}>{actions}</div>
    </>
  );
};

export default DashboardSlidingNav;
